// extracted by mini-css-extract-plugin
export default {"btn_wrapper":"MultipleSelectBtns_btn_wrapper__GcLl0","btn":"MultipleSelectBtns_btn__YM1Jp","selected":"MultipleSelectBtns_selected__u5VDE"};